import { Icon } from "antd";
import React from "react";
import classNames from "classnames";
import styles from "./Message.module.scss";

const Message = ({ info, error }) => {
	if (error || info) {
		return (
			<div className={styles.forgot_password_message}>
				<Icon
					type="info-circle"
					className={classNames(styles.icon, {
						[styles.error_icon]: !!error,
						[styles.info_icon]: !!info,
					})}
				/>
				<span>{error || info}</span>
			</div>
		);
	}
	return null;
};

export default Message;
